<template>
    <div>
        <Panel
            :title="$t('Viber Accounts')"
            :add-button="canEdit ? $t('Add Account') : ''"
            :delete-button="selected.length > 0"
            :page="page"
            :total-rows="totalRows"
            @change="changePage"
            @delete="handleDelete"
            @input="openForm(-1)"
        >
            <table id="viberaccounts_table" class="cic-table">
                <thead>
                    <tr>
                        <th>{{ $t('Name') }}</th>
                        <th>{{ $t('Access Token') }}</th>
                        <th v-if="canEdit"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="account in accounts" @click="(evt) => handleOpen(account.accountId, evt)">
                        <td class="primary">
                            {{ account.accountName }}
                        </td>
                        <td>{{ account.accessToken }}</td>
                        <td v-if="canEdit" class="td-checkbox">
                            <cic-checkbox
                                :value="selected.includes(account.accountId)"
                                @click="handleSelected(account.accountId)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </Panel>

        <EditViberAccount
            v-if="item !== null && !$store.showLoadingOverlay"
            :item="item"
            @blur="closePopup"
            @input="saveItem"
            @change="updateFieldValue"
        />

        <div v-if="$store.showLoadingOverlay" class="cic-overlay"></div>
    </div>
</template>

<script>
    import Panel from '@/components/container/Panel';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import TableUtils from '@/mixins/TableUtils';
    import { deleteItems, load, save } from '@/utils/Http';
    import EditViberAccount from './EditViberAccount';

    export default {
        name: 'ViberAccounts',
        components: {
            CicCheckbox,
            EditViberAccount,
            Panel,
        },
        mixins: [TableUtils],
        data() {
            return {
                selected: [],
                accounts: [],
                page: 1,
                totalRows: 0,
                item: null,
            };
        },
        computed: {
            canEdit() {
                return this.$store.hasRight('EDIT_ACCESS_TYPE_20');
            },
        },
        created() {
            this.loadTable();
        },
        methods: {
            // Load table of search results
            loadTable() {
                this.closePopup();
                load('viber/get', { page: this.page }, (response) => {
                    this.accounts = response.accounts;
                    this.totalRows = response.totalRows;
                });
            },

            openForm(accountId) {
                if (accountId > 0) {
                    load('viber/edit', { accountId: accountId }, (response) => {
                        this.item = response.data;
                    });
                } else {
                    this.item = {
                        accountId: null,
                        accountName: '',
                        accessToken: '',
                    };
                }
            },

            handleDelete() {
                deleteItems('viber/delete', { accountIds: this.selected }, () => {
                    this.selected = [];
                    this.loadTable();
                });
            },

            saveItem() {
                save('viber/update', { data: JSON.stringify(this.item) }, () => {
                    this.selected = [];

                    if (!this.item.accountId) {
                        this.page = 1;
                    }
                    this.loadTable();
                });
            },
        },
    };
</script>
